import type { TranscriptCompareUtterance } from '../components/CompareTranscriptLayout';
import type { TSearchableWord } from '../types/TSearch';

export const flattenCompareTokens = (utterances: TranscriptCompareUtterance[]): TSearchableWord[] =>
  utterances.flatMap((utterance, utteranceIndex) =>
    utterance.tokens.flatMap((token, tokenIndex) => {
      if (token.operation === 'deletion') {
        return [];
      }

      const isPrimaryText = token.operation === 'match';
      const text = isPrimaryText ? token.primaryText : token.compareText;

      if (!text?.trim()) {
        return [];
      }

      return [
        {
          key: `${utteranceIndex}:${tokenIndex}:${isPrimaryText ? 'primary' : 'compare'}`,
          itemIndex: utteranceIndex,
          text,
        },
      ];
    }),
  );
